(function(){
  "use strict";
  var KEY="siloreparis_a11y";
  var MULT=[1,1.15,1.32,1.5];
  var d=document, root=d.documentElement, body=d.body;
  var panel=d.getElementById("a11y-panel"), toggle=d.getElementById("a11y-toggle"), mask=d.getElementById("a11y-mask");
  if(!panel||!toggle) return;
  var BASE=parseFloat(getComputedStyle(root).fontSize)||16;
  var DEF={fs:0,con:"normal",al:"",lh:false,ls:false,links:false,cursor:false,hideimg:false,noanim:false,dys:false,mask:false,focus:false};
  var state=Object.assign({},DEF);
  try{var s=localStorage.getItem(KEY); if(s) state=Object.assign(state,JSON.parse(s));}catch(e){}
  function save(){try{localStorage.setItem(KEY,JSON.stringify(state));}catch(e){}}
  var lex=false;
  function loadLexend(){ if(lex)return; lex=true; var l=d.createElement("link"); l.rel="stylesheet"; l.href="https://fonts.googleapis.com/css2?family=Lexend:wght@400;600&display=swap"; d.head.appendChild(l); }
  function upd(sel,fn){ var n=panel.querySelectorAll(sel); for(var i=0;i<n.length;i++) n[i].classList.toggle("active",fn(n[i])); }
  function apply(){
    if(state.fs>0) root.style.setProperty("font-size",(BASE*MULT[state.fs]).toFixed(2)+"px","important");
    else root.style.removeProperty("font-size");
    root.classList.toggle("a11y-invert",state.con==="invert");
    root.classList.toggle("a11y-contrast",state.con==="contrast");
    root.classList.toggle("a11y-gray",state.con==="gray");
    body.classList.toggle("a11y-alr",state.al==="r");
    body.classList.toggle("a11y-alc",state.al==="c");
    body.classList.toggle("a11y-all",state.al==="l");
    body.classList.toggle("a11y-lh",state.lh);
    body.classList.toggle("a11y-ls",state.ls);
    body.classList.toggle("a11y-links",state.links);
    body.classList.toggle("a11y-cursor",state.cursor);
    body.classList.toggle("a11y-hideimg",state.hideimg);
    body.classList.toggle("a11y-noanim",state.noanim);
    body.classList.toggle("a11y-dys",state.dys);
    body.classList.toggle("a11y-focus",state.focus);
    if(state.dys) loadLexend();
    mask.classList.toggle("on",state.mask);
    upd("[data-fs]",function(b){return +b.dataset.fs===state.fs;});
    upd("[data-con]",function(b){return b.dataset.con===state.con;});
    upd("[data-al]",function(b){return b.dataset.al===state.al;});
    upd("[data-tg]",function(b){return !!state[b.dataset.tg];});
    save();
  }
  function open(o){panel.classList.toggle("open",o);toggle.setAttribute("aria-expanded",o);}
  toggle.addEventListener("click",function(){open(!panel.classList.contains("open"));});
  panel.addEventListener("click",function(e){
    var b=e.target.closest("button"); if(!b)return;
    if(b.id==="a11y-close"){open(false);}
    else if(b.dataset.fs!==undefined){state.fs=+b.dataset.fs;apply();}
    else if(b.dataset.con!==undefined){state.con=b.dataset.con;apply();}
    else if(b.dataset.al!==undefined){state.al=(state.al===b.dataset.al?"":b.dataset.al);apply();}
    else if(b.dataset.tg!==undefined){state[b.dataset.tg]=!state[b.dataset.tg];apply();}
    else if(b.id==="a11y-reset"){state=Object.assign({},DEF);apply();}
  });
  d.addEventListener("mousemove",function(e){ if(state.mask) mask.style.top=(e.clientY-60)+"px"; });
  apply();
})();